import React from 'react'
import Props from 'prop-types'

import Container from 'components/Styled/Container'
import DownloadButton from 'components/DownloadButton'
import Navigation from 'components/Navigation'
import ImageHand from './assets/zoe-web-arm.jpg'
import ImageHand2x from './assets/zoe-web-arm@2x.jpg'
import ImageHand3x from './assets/zoe-web-arm@3x.jpg'
import { Header, Heading, MainImage, Arrow, Spacer } from './styled'

const HomepageHeader = ({ onArrowClick }) => (
  <Header>
    <Navigation isMobileVisible inverted absolute />

    <Spacer />

    <Container>
      <Heading>
        <span>The World’s Best Ranked</span> Dating App <br />for&nbsp;Queer Women
      </Heading>

      <div>
        <DownloadButton inverted type="apple">App Store</DownloadButton>
        <DownloadButton inverted type="google">Google Play</DownloadButton>
      </div>
    </Container>

    <MainImage
      src={ImageHand}
      srcSet={`${ImageHand2x} 2x, ${ImageHand3x} 3x`}
      alt="Zoe – The World’s Best Ranked Dating App for Queer Women"
    />

    <Arrow onClick={onArrowClick} />
  </Header>
)

HomepageHeader.propTypes = {
  onArrowClick: Props.func.isRequired,
}

export default HomepageHeader
